// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2Wo28","vLegacy":"SelectSecondary_vLegacy__3nuQy","error":"SelectSecondary_error__12i74","disabled":"SelectSecondary_disabled__2B2lU"};